import { NgClass } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LibSharedCommonModule } from '@solvace/common';
import { SvcFilledBtnIconComponent } from './svc-filled-btn-icon.component';

@NgModule({
  declarations: [
    SvcFilledBtnIconComponent
  ],
  imports: [
    LibSharedCommonModule,
    MatProgressSpinnerModule,
    MatIconModule,
    NgClass,
  ],
  exports: [
    SvcFilledBtnIconComponent
  ]
})
export class SvcFilledBtnIconModule { }
